import { AddTeam } from './../Distributor.model';
import {fromEvent as observableFromEvent,  Observable } from 'rxjs';

import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'app/auth/authentication.service';
import { Helpers } from 'app/helpers/helpers.service';
import { User } from 'app/user/user.model';
import { UserService } from 'app/user/user.service';
import { ContentService } from 'app/views/content/content.service';
import { FineUploader } from 'fine-uploader';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { DistributorService } from '../distributor.service';
import { FileDatabase, FileDatasource } from '../uploader/file-list/file-list.component';

@Component({
  selector: 'helpers-image',
  templateUrl: './helpers-image.component.html',
  styleUrls: ['./helpers-image.component.scss']
})
export class HelpersImageComponent implements OnInit, AfterViewInit {
  @Output()
  eventImage: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  divId: string;

  @Input()
  fileType: number;

  @Input()
  image: string = null;

  @Input()
  userId: number;

  @Input()
  languageId: number;

  canSee = false;

  user: AddTeam;
  editFileForm: FormGroup;
  uploader: FineUploader;
  imagesAllowedExtensions = ['jpeg', 'jpg', 'gif', 'png'];
  documentsAllowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt', 'rtf', 'html', 'zip', 'rar', 'svg'];
  directoryGuid?: string;
  filenameToDelete?: string;
  modalRef: BsModalRef;
  fileId: number;
  fileName: string;
  helpers: any;
  product: any;


  displayedColumns = ['filename', 'filetime', 'filepath', 'actions'];
  dataSource: FileDatasource | null;
  database: FileDatabase;

  @ViewChild('filter', {static: true}) public filter: ElementRef;

  @ViewChild(MatSort, {static : true}) public sort: MatSort;

  @ViewChild(MatPaginator, {static: true}) public paginator: MatPaginator;

  constructor(private distributorsService: DistributorService, private userService: UserService, private modalService: BsModalService,
    private toastr: ToastrService, private fb: FormBuilder, private spinnerService: NgxSpinnerService,
    private authService: AuthenticationService) {
    this.editFileForm = this.fb.group({
      name: ['', Validators.required]
    });
    this.helpers = new Helpers();
  }

  attachToTeamUser(fileObject: any) {
    this.spinnerService.show();
    this.hide(true);
    this.distributorsService.attachTeamMainImage(fileObject, this.userId).subscribe(user => {
        this.image = user.main_image_src;
        this.spinnerService.hide();
        this.eventImage.emit(this.image);
        this.toastr.success('Image saved','Success');
      });
  }
  detachFromTeam(): void {
    this.spinnerService.show();
    this.hide(true);
    this.distributorsService.detachTeamMainImage(this.userId).subscribe(item => {
      this.image = null;
      this.spinnerService.hide();
      this.toastr.success('Image removed','Success');
    });
  }

  show(e: any) {
    this.canSee = true;
  }

  hide(e: any) {
    this.canSee = false;
  }
  ngOnInit(): void {
    this.database = new FileDatabase(this.distributorsService);
    this.dataSource = new FileDatasource(this.database, this.paginator, this.sort)
    if (this.filter) {
      observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
        debounceTime(150),
        distinctUntilChanged(),)
        .subscribe(() => {
          if (!this.dataSource) {
            return;
          }
          this.dataSource.filter = this.filter.nativeElement.value;
        });
    }
  }
  onFileUploaded() {
    this.distributorsService.getUserFiles().subscribe(
      files => {
        this.database.updateData(files);
      });
  }

  remove(filename: string): void {
    this.spinnerService.show();
    // this.distributorsService.deleteUserFile(filename)
    //   .subscribe(() => {
    //     this.toastr.success('File deleted successfully', '');
    //     this.deleteRowDataTable(filename);
    //     this.spinnerService.hide();
    //   }
    //   );
  }

  deleteRowDataTable(filename) {
    const dsData = this.database.data;
    const itemIndex = dsData.findIndex(obj => obj['filename'] === filename);
    dsData.splice(itemIndex, 1)
    this.database.dataChange.next(dsData);
  }
  copyTextToClipboard(text) {
    const txtArea = document.createElement('textarea');

    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = text;
    document.body.appendChild(txtArea);
    txtArea.select();
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      this.toastr.success('File path copied to the clipboard');
      if (successful) {
        return true;
      }
    } catch (err) {
      this.toastr.success('Ups! Something went wrong :(');
    }
    document.body.removeChild(txtArea);
    return false;
  }

  ngAfterViewInit() {
    this.getInitialData();
  }

  getInitialData() {
    this.userService.getUser().subscribe(user => {
      this.user = user;
      this.uploader = this.configureUploader(this.divId, this);
    })
    this.distributorsService.getUserFiles().subscribe(
      files => {
        this.database.updateData(files);
      });
  }

  configureUploader(elementId: string, that: any) {
    const uri: string = environment.apiUrl + '/uploader';
    return new FineUploader({
      element: document.getElementById(elementId),
      autoUpload: true,
      request: {
        endpoint: uri,
        customHeaders: {
          'Authorization': `Bearer ${that.authService.getToken()}`
        }
      },
      validation: {
        allowedExtensions: that.imagesAllowedExtensions.concat(that.documentsAllowedExtensions)
      },

      callbacks: {
        onSubmit: function (options) {
          this.setParams({ isUserImage: true });
          that.spinnerService.show();
        },
        onAllComplete: function (succeeded, failed) {
          this.reset();
          that.spinnerService.hide();
          if (succeeded) {
            that.show(true);
            that.distributorsService.getUserFiles().subscribe(
              files => {
                that.database.updateData(files);
              });
          }
        }
      }
    });
  }
}
